module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-vietnamese-700-normal.woff2?3425a701027d0699e369d364c89b9395";